<template>
  <div class="slider-dots" ref="rootRef">
    <div class="dots-track">
      <div
        v-for="(_, i) in total"
        :key="i"
        class="dot"
        :class="{ active: i === activeIndex }"
        :style="getDotStyle(i)"
        @click="handleSelect(i)"
        role="button"
        aria-label="slide dot"
        :aria-current="i === activeIndex">
        <div v-if="i === activeIndex" class="progress" :key="`prog-${activeIndex}`" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref, watch } from "vue";

const props = defineProps({
  total: { type: Number, required: true },
  activeIndex: { type: Number, required: true },
  // Размер точки и зазор можно переопределить через пропсы при желании
  dotSize: { type: Number, default: 6 }, // px
  gap: { type: Number, default: 4 }, // px
  capsuleWidth: { type: Number, default: 16 }, // px — ширина капсулы в Figma
});

const emit = defineEmits(["select"]);

const rootRef = ref(null);

function handleSelect(index) {
  emit("select", index);
}

watch(
  () => props.activeIndex,
  async () => {
    await nextTick();
    // прогресс перезапустится за счёт :key на .progress
  },
);

function getDotStyle(i) {
  const isActive = i === props.activeIndex;
  const widthPx = isActive ? props.capsuleWidth : props.dotSize;
  const heightPx = props.dotSize;
  return {
    width: `${widthPx}px`,
    height: `${heightPx}px`,
  };
}
</script>

<style scoped lang="scss">
.slider-dots {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px 16px; // как в Figma
}

.dots-track {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px; // как в Figma
}

.dot {
  width: 6px; // переопределяется инлайном
  height: 6px; // переопределяется инлайном
  position: relative; // чтобы .progress позиционировался внутри точки/капсулы
  overflow: hidden; // чтобы заливка не выходила за скругления
  border-radius: 40px; // как в Figma
  background: #4d4d4d; // неактивная точка из Figma
  cursor: pointer;
  transition:
    background 200ms ease,
    width 280ms cubic-bezier(0.22, 1, 0.36, 1);

  &.active {
    background: rgba(77, 77, 77, 0.4); // трек капсулы как в макете
    border-radius: 20px; // форма капсулы
  }
}

.progress {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  background: #fafafa; // заливка
  border-radius: 40px; // совпадает с формой капсулы контейнера
  // Анимируем с помощью transform для более плавной отрисовки на GPU
  transform-origin: left center;
  transform: scaleX(0) translateZ(0);
  animation: fill-scale var(--progress-duration, 6s) linear forwards;
  will-change: transform;
}

@keyframes fill-scale {
  from {
    transform: scaleX(0) translateZ(0);
  }
  to {
    transform: scaleX(1) translateZ(0);
  }
}
</style>
